import { createFileRoute, redirect } from '@tanstack/react-router';
import { ApplicationPage } from '@/pages/Application';
import { queryClient } from '@/app/providers/QueryProvider/client.ts';
import { fetchMediationOptions } from '@/entities/mediation/api/fetchMediationOptions.ts';
import { authStore } from '@/app/localStorage/utils.ts';

export const Route = createFileRoute('/_layout/application/')({
  component: ApplicationPage,
  validateSearch: (search: Record<string, unknown>) => {
    if (typeof search.mediationId !== 'number') {
      throw new Error('mediationId is required');
    }
    return {
      mediationId: search.mediationId,
    };
  },
  beforeLoad: ({ search }) => {
    const token = authStore.getToken();
    if (!token) {
      throw redirect({ to: '/auth', replace: true });
    }
    if (typeof search.mediationId !== 'number') {
      throw redirect({ to: '/', replace: true });
    }
  },
  loaderDeps: ({ search }) => ({ mediationId: search.mediationId }),
  loader: async ({ deps }) => {
    const { mediationId } = deps;
    const response = await queryClient.fetchQuery(
      fetchMediationOptions({ mediationId })
    );

    if (!response) {
      throw redirect({ to: '/', replace: true });
    }

    return response.data.mediation;
  },
});
